import { Participation } from '@models/ops-event/participation';

export class VisitorParticipation extends Participation {
  visitorId: string;

  constructor(data = {}) {
    super(data);

    this.visitorId = data['visitorId'];
  }
}
